<template>
  <div>
    <mt-header fixed :title="getOkTitle" class="title2">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
      <mt-button slot="right" @click="moreBtnClickHandler">更多</mt-button>
    </mt-header>
    <div>
      <mt-navbar v-model="active">
        <mt-tab-item :id="1">{{ getOkDayTapTitle }}</mt-tab-item>
        <mt-tab-item :id="2">{{ getOkMonthTapTitle }}</mt-tab-item>
      </mt-navbar>
      <mt-tab-container v-model="active">
        <mt-tab-container-item :id="1">
          <detailed-list-examine v-if="$route.query.pageName === 'OverviewListExamine'" ref="detail1" :flag="$route.query.active" :mark="1" :actived="active" />
          <detailed-list v-if="$route.query.pageName === 'OverviewList'" ref="detail1" :flag="$route.query.active" :mark="1" :actived="active" />
          <detailed-tips v-if="$route.query.pageName === 'OverviewTips'" ref="detail1" :mark="1" />
        </mt-tab-container-item>
        <mt-tab-container-item :id="2">
          <detailed-list-examine v-if="$route.query.pageName === 'OverviewListExamine'" ref="detail2" :flag="$route.query.active" :mark="2" :actived="active" />
          <detailed-list v-if="$route.query.pageName === 'OverviewList'" ref="detail2" :flag="$route.query.active" :mark="2" :actived="active" />
          <detailed-tips v-if="$route.query.pageName === 'OverviewTips'" ref="detail2" :mark="2" />
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
  </div>
</template>

<script>
import DetailedList from '@/components/DetailedList.vue';
import DetailedListExamine from '@/components/DetailedListExamine.vue';
import DetailedTips from '@/components/DetailedTips.vue';

export default {
  name: 'Detailed',
  components: {
    DetailedList,
    DetailedListExamine,
    DetailedTips,
  },
  data() {
    return {
      title: '',
      tapTitleDay: '',
      tapTitleMonth: '',
      parentName: '',
      parentActive: -1,
      active: 1,
    };
  },
  mounted() {
    this.parentName = this.$route.query.pageName;
    this.parentActive = this.$route.query.active;
  },
  computed: {
    getOkTitle() {
      let title = '';
      if (this.parentName === 'OverviewList' || this.parentName === 'OverviewListExamine') {
        switch (this.parentActive) {
          case '0':
            title = '汇总业绩';
            break;
          case '1':
            title = '个人业绩';
            break;
          case '2':
            title = '代理业绩';
            break;
        }
      } else if (this.parentName === 'OverviewTips') {
        title = '我的收益';
      } else {
        title = '';
      }
      return title;
    },
    getOkDayTapTitle() {
      let title = '';
      if (this.parentName === 'OverviewList' || this.parentName === 'OverviewListExamine') title = '日业绩';
      else if (this.parentName === 'OverviewTips') title = '日收益';
      else title = '';
      return title;
    },
    getOkMonthTapTitle() {
      let title = '';
      if (this.parentName === 'OverviewList' || this.parentName === 'OverviewListExamine') title = '月业绩';
      else if (this.parentName === 'OverviewTips') title = '月收益';
      else title = '';
      return title;
    },
  },
  methods: {
    moreBtnClickHandler() {
      if (this.active === 1) this.$refs.detail1.openDatePicker();
      else if (this.active === 2) this.$refs.detail2.openDatePicker();
    },
  },
};
</script>
